import { IconResolver } from "icon-resolver";
import styles from "./index.module.css";
import classNames from "classnames";
import { combineId } from "@fixparts/testid/index.ts";
import { useStoreSync } from "../product-area/store/sync";
import { useMemo } from "preact/hooks";

type IconProps = {
  name?: string;
  src?: string;
  library?: string;
  width?: number;
  height?: number;
  className?: string;
  "data-testid"?: string
};

export const Icon = (props: IconProps) => {
  const resolver = IconResolver.instance;
  const url = useMemo(() => {
    return props.name
      ? resolver.createClientLibraryIconPath(`${props.name}.svg`, props.library)!
      : resolver.tranformUrlToRelativePath(props.src!)!;
  }, [props.name, props.library, props.src]);

  const content = resolver.getResourse(url) ?? '';
  const style = useMemo(() => ({
    ...props.width ? { width: `${props.width}px` } : {},
    ...props.height ? { height: `${props.height}px` } : {},
  }), [props.width, props.height]);
  const html = useMemo(() => ({ __html: content }), [content]);

  useStoreSync(resolver.sync);

  return (
    <span
      style={style}
      className={classNames(styles.icon, props.className)}
      aria-label={props.name}
      role="img"
      dangerouslySetInnerHTML={html}
      {...combineId(props)}
    />
  );
};
